/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { updateUserConfigRequest as updateUserConfig } from '../../actions/actionsSet/account';
import { setItem } from '../../utils/localStorage';
import { track, sensorEventTypes } from '../../utils/sensors';
import RateIcon from './RateIcon';
import { setNativeCurrency } from '../../actions/load';

const MenuBox = styled.ul`
  width: 100%;
  list-style-type: none;
  border-radius: 3px;
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-wrap: wrap;
`;
const MenuItem = styled.li`
  flex-basis: 33.33%;
  padding: 12px 0 12px 25px;
  cursor: pointer;
  color: #fff;
  font-weight: 500;
  text-align: left;
  font-size: 14px;
  :hover {
    color: ${({ theme }) => theme.highlight};
    background:rgba(255,255,255,0.08);
  }
  i {
    margin-right: 6px;
  }
`;

type Props = {
  currencyList: Array<Object>,
  setNativeCurrency: Function,
  isLoggedIn: boolean,
  locale: string,
};

type NativeCurrency = {
  configType: string,
  configName: string,
};

const mapDispatchToProps = { setNativeCurrency };
const mapStateToProps = ({ currencyList, isLoggedIn, locale }) => ({
  currencyList,
  isLoggedIn,
  locale,
});

export default
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class RateSwitch extends React.Component<Props> {
  static defaultProps = {
    currencyList: [],
    setNativeCurrency: () => {},
    isLoggedIn: false,
    locale: 'en',
  };

  _setNativeCurrency = (config: NativeCurrency) => {
    const { locale } = this.props;

    track(sensorEventTypes.SWITCH_FIAT_RATE, {
      fiatCurrency: config.configName,
    });
    this.props.setNativeCurrency(config);
    if (this.props.isLoggedIn) {
      try {
        updateUserConfig(config, locale);
      } catch (e) {
        // donothing
      }
    } else {
      setItem(window.localStorage, 'userPreferredCurrency', config.configName);
    }
  };

  render() {
    return (
      <MenuBox>
        {this.props.currencyList.map(({ name, pair }) => (
          <MenuItem
            key={pair}
            onClick={() => this._setNativeCurrency({ configType: 'nativeCurrency', configName: pair })
            }
          >
            <RateIcon type={name.toLowerCase()} /> {name}
          </MenuItem>
        ))}
      </MenuBox>
    );
  }
}
